//  @flow

import React from 'react';
import { withTranslation } from 'react-i18next';
//  $Ignore
import { bindActionCreators } from 'redux';
//  $Ignore
import { connect } from 'react-redux';

import FormManager from '../../Components/FormManager';
import InputManager from '../../Components/InputManager';
import Button from '../../Components/Button';
import Alert from '../../Components/Alert';

import { contactToUs, setAlertStatus } from '../../actions/contactUsForm';
import { validateEmail, validateMobile } from '../../helpers/helper';
import ImageBlurFallback from '../../Components/ImageBlurFallback';
import ENQUIRY_PNG from '../../Assets/v2/workshop/Enquiry.png';

const hearAboutUsList = [
  { name: 'Linkedin', value: 'linkedin' },
  { name: 'Facebook', value: 'facebook' },
  { name: 'Instagram', value: 'instagram' },
  { name: 'Email', value: 'email' },
  { name: 'Youtube', value: 'youtube' },
  { name: 'We Called You', value: 'we_called_you' },
  {
    name: 'From a Webinar Organized By Your Campus',
    value: 'webinar'
  },
  { name: 'Word of Mouth', value: 'word_of_mouth' },
  { name: 'Articles', value: 'article' },
  { name: 'Search Engine', value: 'search_engine' },
  { name: 'Reddit', value: 'reddit' },
  { name: 'HackerEarth', value: 'hackerearth' },
  { name: 'Geeks For Geeks', value: 'geeks_for_geeks' },
  { name: 'Others', value: 'others' }
];

type inputContactParams = {
  name: string,
  mobile: string,
  email: string,
  message: string,
  hear_about_us: string
};
type FormProps = {
  contactToUs: (params: inputContactParams) => void,
  setAlertStatus: () => void,
  className: string
};

type FormState = {
  isLoading: boolean,
  alertActive: boolean,
  sentSuccess: boolean
};

class NewForm extends React.Component<FormProps, FormState> {
  constructor(props: FormProps) {
    super(props);

    this.state = {
      isLoading: false,
      alertActive: false,
      sentSuccess: false
    };
  }

  toggleLoading = () => {
    this.setState(prevState => ({ isLoading: !prevState.isLoading }));
  };

  validateName = (val: string) => val.trim().length < 3;

  validateEmail = (val: string) => !validateEmail(val.trim());

  validatePhone = (val: string) => !validateMobile(val.trim());

  validateText = (val: string) => val.trim().length <= 0;

  onSubmit = async (data, resetForm) => {
    const updatedData = {
      ...data,
      hear_about_us: hearAboutUsList.find(
        item => item.name === data.hear_about_us
      ).value
    };

    Object.assign(updatedData, {
      origin: this.props.origin ? this.props.origin : 'workshop'
    });
    try {
      this.toggleLoading();
      await this.props.contactToUs(updatedData);
      this.toggleLoading();

      resetForm();
      this.setSuccess(true);
      this.setAlert();
    } catch (err) {
      this.setSuccess(false);
      this.toggleLoading();
      this.setAlert();
    }
  };

  setSuccess = (status: boolean) => {
    this.setState({ sentSuccess: status });
  };

  setAlert = () => {
    this.setState({ alertActive: true });
    setTimeout(() => {
      this.setState({ alertActive: false });
    }, 3000);
  };

  render = () => {
    const { t, className = '' } = this.props;

    return (
      <section className="workshop-contact-banner">
        <div className={`workshop-contact-form-container ${className}`}>
          <div className="workshop-contact-form-left-container">
            <ImageBlurFallback
              src={ENQUIRY_PNG}
              alt="Meet and Greet"
              className="workshop-contact-form-left-image"
            />
            <p className="workshop-contact-form-call">
              For further queries call on{' '}
              {this.props.isIITWorkshop
                ? '74395 15383'
                : this.props.isInternship
                ? '8240020577'
                : '9903319317 or 7439515383'}
            </p>
          </div>
          <div className="workshop-contact-form-content">
            <p className="workshop-contact-form-heading">
              {this.props.isInternship
                ? t("Still confused? Let's connect")
                : t('Submit Your Enquiry')}
            </p>
            {this.state.alertActive && (
              <Alert
                title={
                  this.state.sentSuccess
                    ? t('alertSuccessTitle')
                    : t('alertFailedTitle')
                }
                type={this.state.sentSuccess ? 'success' : 'failed'}
              />
            )}

            <FormManager
              className="workshop-contact-form"
              onSubmit={this.onSubmit}>
              <InputManager
                id="name"
                placeholder={t('inputName')}
                className="workshop-contact-form-field"
                value={this.state.name}
                validate={this.validateName}
                required={true}
                emptyText={t('nameEmptyText')}
                invalidText={t('nameInvalidText')}
              />

              <InputManager
                id="email"
                placeholder={t('inputEmail')}
                className="workshop-contact-form-field"
                value={this.state.email}
                validate={this.validateEmail}
                required={true}
                emptyText={t('emailEmptyText')}
                invalidText={t('emailInvalidText')}
              />

              <InputManager
                id="phone"
                placeholder={t('inputPhone')}
                className="workshop-contact-form-field"
                value={this.state.mobile}
                validate={this.validatePhone}
                required={true}
                emptyText={t('phoneEmptyText')}
                invalidText={t('phoneInvalidText')}
              />

              <InputManager
                id="message"
                type="textarea"
                placeholder={t('inputMessage')}
                className="workshop-contact-form-field-area"
                value={this.state.message}
                validate={this.validateText}
                required={true}
                emptyText={t('msgEmptyText')}
                invalidText={t('msgInvalidText')}
              />

              <InputManager
                id="hear_about_us"
                type="select"
                options={hearAboutUsList.map(item => item.name)}
                placeholder="Where did you Hear About us?"
                className="workshop-contact-form-field"
                value={this.state.hear_about_us}
                validate={this.validateText}
                required={true}
                emptyText="Hear about us is required"
              />

              <Button
                indicatorColor="white"
                className="workshop-contact-submit-btn"
                loading={this.state.isLoading}
                type="submit"
                text="Submit"
              />
            </FormManager>
          </div>
        </div>
      </section>
    );
  };
}

const mapStateToProps = state => ({
  alertStatus: state.contact.alertStatus
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      contactToUs,
      setAlertStatus
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(NewForm));



// WEBPACK FOOTER //
// ./src/Pages/Workshop/ContactForm.js